export default __webpack_public_path__ + "static/media/copy-icon.0fde0971.svg";